module.exports = __webpack_public_path__ + "static/media/capa_27_causos.69db8c45.png";